export const ALL_EXPANDS_EMPLOYEE = 'profile,vsdstats,private,contacts,persons,hr,mentor';
export const ALL_VP_EXPANDS_EMPLOYEE = 'profile,vsdstats,private,contacts,sales,persons,hr,mentor';

export const FIRST_DAY_COUNT_VSD = '2019-11-27';

export enum EMPLOYEE_POSITION {
  teamLead = 'Team Lead',
  techLead = 'Tech Lead',
}
